var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ve-table',{staticStyle:{"width":"100%"},attrs:{"columns":_vm.columns,"table-data":_vm.debtCustomers,"row-key-field-name":"id","checkbox-option":_vm.checkboxOption,"max-height":500,"virtual-scroll-option":_vm.virtualScrollOption}})}
var staticRenderFns = []

export { render, staticRenderFns }